var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6348 20.7275V12.7662H16.3582L16.7668 9.66268H13.6348V7.6815C13.6348 6.78323 13.8881 6.17107 15.2029 6.17107L16.877 6.1704V3.39446C16.5875 3.35756 15.5937 3.27295 14.437 3.27295C12.0216 3.27295 10.368 4.71903 10.368 7.37413V9.66268H7.63635V12.7662H10.368V20.7275H13.6348Z",
    fill: "#F1DFDA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_105_6310",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 3,
    width: 10,
    height: 18
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6348 20.7275V12.7662H16.3582L16.7668 9.66268H13.6348V7.6815C13.6348 6.78323 13.8881 6.17107 15.2029 6.17107L16.877 6.1704V3.39446C16.5875 3.35756 15.5937 3.27295 14.437 3.27295C12.0216 3.27295 10.368 4.71903 10.368 7.37413V9.66268H7.63635V12.7662H10.368V20.7275H13.6348Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_105_6310)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.e8377477ece43a342a352aba66c478fe.svg";
export { ForwardRef as ReactComponent };